import * as classnames from "classnames";

/**
 * Prop interface
 */
export interface TadaMiniProps {
  score?: number;
  totalScore?: number;
  startAnimation?: boolean;
  onFinishAnimation?: () => void;
  isBlack?: boolean;
  className?: string;
  children?: {};
}

/**
 * React Component
 */
export default function TadaMini({
  className,
  score = 0,
  totalScore = 0,
  startAnimation,
  isBlack,
  onFinishAnimation,
}: TadaMiniProps) {
  let timer = 0;

  const rootStyle = classnames("code-c-tada-mini", {
    "is-black": isBlack,
    "is-animate": startAnimation,
    [`${className}`]: Boolean(className),
  });

  if (startAnimation) {
    if (timer) {
      window.clearTimeout(timer);
    }
    timer = window.setTimeout(() => {
      if (typeof onFinishAnimation === "function") {
        onFinishAnimation();
      }
    }, 2000);
  }

  return (
    <div className={rootStyle}>
      <div className="code-c-tada-mini__icon">
        <div className="code-c-tada-mini__body" />
        <div className="code-c-tada-mini__dust" />
      </div>
      <div className="code-c-tada-mini__score">
        <div className="code-c-tada-mini__score-top">{score}</div>
        <div className="code-c-tada-mini__score-border" />
        <div className="code-c-tada-mini__score-bottom">{totalScore}</div>
      </div>
    </div>
  );
}
